import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET } from '@angular/router';
import { filter } from 'rxjs/operators';

interface IBreadcrumb {
  label: string;
  icon: string;
  params: Params;
  url: string;
  isLast: boolean;
}

@Component({
  selector: 'swb-header-breadcrumbs',
  templateUrl: './header-breadcrumbs.component.html'
})
export class HeaderBreadcrumbsComponent implements OnInit {

  public breadcrumbs: IBreadcrumb[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.breadcrumbs = [];
  }

  ngOnInit() {
    // call on first load
    this._initBreadcrumbs();

    // and then subscribe to the NavigationEnd event
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      // set breadcrumbs
      this._initBreadcrumbs();
    });
  }

  private _initBreadcrumbs() {
    const root: ActivatedRoute = this.activatedRoute.root;
    this.breadcrumbs = this._getBreadcrumbs(root);
  }

  private _getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
    const ROUTE_DATA_BREADCRUMBS = 'breadcrumbs';

    // get the child routes
    const children: ActivatedRoute[] = route.children;

    // return if there are no more children
    if (children.length === 0) {
      // set last element as last
      if (breadcrumbs[breadcrumbs.length - 1]) {
        breadcrumbs[breadcrumbs.length - 1].isLast = true;
      }
      return breadcrumbs;
    }

    // iterate over each children
    for (const child of children) {

      // verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      // verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMBS) || child.snapshot.url.length === 0) {
        return this._getBreadcrumbs(child, url, breadcrumbs);
      }

      // get the route's URL segment
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');

      // append route URL to URL
      url += `/${routeURL}`;

      const breadcrumbData = child.snapshot.data[ROUTE_DATA_BREADCRUMBS];

      // add breadcrumb
      const breadcrumb: IBreadcrumb = {
        label: (breadcrumbData.label || ''),
        icon: (breadcrumbData.icon || null),
        params: child.snapshot.params,
        url: url,
        isLast: false
      };

      breadcrumbs.push(breadcrumb);

      // recursive
      return this._getBreadcrumbs(child, url, breadcrumbs);
    }
  }


}
